import React, { useState, useEffect } from "react";
import {
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Container,
  Typography,
  ImageList,
  ImageListItem,
} from "@mui/material";
import { GetToken } from "../../../../actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import api from "../../../../utils/apidsf";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";
import { Form } from "usetheform";

import axios from "../../../../utils/apidsf";

// css
// import "./CreateUser.css";

const CreateUser = () => {
  const dispatch = useDispatch();

  const selector = useSelector((state) => state);
  const navigate = useNavigate();
  const [filetoken, setfiletoken] = useState("");
  const [data, setdata] = useState({
    email: "",
    rawimage: [],
    name: "",
    category: "student",
    phone: "",
    password: "",
  });

  useEffect(() => {
    dispatch(GetToken());
  }, []);
  useEffect(() => {
    setfiletoken(selector?.adminReducer?.token);
  }, [selector]);
  const onsubmit = async () => {
    try {
      let token = JSON.parse(localStorage.getItem("token"));

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      };
      const form = new FormData();
      form.append("file", data?.rawimage);
      await fetch("https://assets.thelexpedia.com//wp-json/wp/v2/media", {
        method: "POST",
        headers: {
          Authorization: `Bearer ${filetoken}`,
        },
        body: form,
      })
        .then((res) => res.json())
        .then(async (result) => {
          if (result?.source_url) {
            let myValue = {
              email: data?.email,
              role: "user",
              image: result.source_url,
              name: data?.name,
              category: data?.category,
              phone: data?.phone,
              password: data?.password,
              verified: true,
            };
            try {
              await api.post(`/admin/`, myValue, config);

              swal({
                title: "Success!",
                text: "User Craeted",
                icon: "success",
                button: "Ok!",
              }).then((value) => {
                navigate("/admin/user-list");
              });
            } catch (error) {
              console.log(error?.response?.data?.error);
              swal({
                title: "Error!",
                text: error?.response?.data?.error,
                icon: "error",
                button: "Ok!",
              });
            }
          } else {
            swal({
              title: "Error!",
              text: "plz select Image ",
              icon: "error",
              button: "Ok!",
            });
          }
        });
    } catch (error) {
      console.error(error);
      swal({
        title: "Error!",
        text: error?.message,
        icon: "error",
        button: "Ok!",
      });
    }
  };

  const texttyle = {
    width: {
      xxs: 100,
      xs: 150,
      sm: 200,
      md: 300,
      lg: 400,
      xl: 500,
    },
  };

  const texttylecon = {
    width: {
      xxs: 100,
      xs: 200,
      sm: 300,
      md: 400,
      lg: 500,
      xl: 600,
    },
  };
  const [image, setimage] = useState([]);
  useEffect(() => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    axios.get("/admin/createcarousel", config).then((e) => {
      console.log(e.data.image[0].imageurl);
      setimage(e?.data?.image[0]?.imageurl);
    });
    return () => {};
  }, []);

  return (
    <div className="admin__createUser">
      <Container
        maxWidth="sm"
        sx={texttylecon}
        className="admin__createUser_div"
      >
        <Typography variant="h5" color="black">
          Carousel Images
        </Typography>

        <ImageList cols={3} rowHeight={164}>
          {image.map(
            (item) => (
              console.log({ item }),
              (
                <ImageListItem key={item}>
                  <img
                    src={`${item}?w=164&h=164&fit=crop&auto=format`}
                    srcSet={`${item}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                    alt={item}
                    loading="lazy"
                  />
                  {/* console.log(item) */}
                </ImageListItem>
              )
            )
          )}
        </ImageList>
      </Container>
    </div>
  );
};

export default CreateUser;
